import PrimeVue from 'primevue/config';
import { autoAnimatePlugin } from '@formkit/auto-animate/vue';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createPersistedStatePlugin } from 'pinia-plugin-persistedstate-2';
import localforage from 'localforage';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';

import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import './assets/main.css';
import 'primeicons/primeicons.css';
import { preset } from './utils/preset';
import clickOutside from './directives/click-outside';

const pinia = createPinia();

pinia.use(
  createPersistedStatePlugin({
    storage: {
      getItem: async (key) => {
        return localforage.getItem(key);
      },
      setItem: async (key, value) => {
        return localforage.setItem(key, value);
      },
      removeItem: async (key) => {
        return localforage.removeItem(key);
      },
    },
  })
);

createApp(App)
  .use(router)
  .use(PrimeVue, {
    theme: {
      preset,
      options: {
        darkModeSelector: '.dark',
      },
    },
  })
  .use(ToastService)
  .use(autoAnimatePlugin)
  .use(pinia)
  .directive('tooltip', Tooltip)
  .directive('click-outside', clickOutside)
  .mount('#app');
